/** Materiales de fila en ajustes Client → Brake Metals finishes (grilla de precios). */
export const BRAKE_METALS_FINISH_MATERIALS = Object.freeze([
    {
        description: 'GALVANIZED SHEET CAL 20 G90',
        name: 'GALVANIZED SHEET',
        thicknessMm: 0.85,
    },
    {
        description: 'GALVANIZED SHEET CAL 22 G90',
        name: 'GALVANIZED SHEET',
        thicknessMm: 0.7,
    },
    {
        description: 'GALVANIZED SHEET CAL 16 G90',
        name: 'GALVANIZED SHEET',
        thicknessMm: 1.5,
    },
    {
        description: 'GALVANIZED SHEET CAL 18 G90',
        name: 'GALVANIZED SHEET',
        thicknessMm: 1.2,
    },
    {
        description: 'ALUMINUM SHEET 1,5 mm',
        name: 'ALUMINUM SHEET',
        thicknessMm: 1.5,
    },
    {
        description: 'ALUMINUM SHEET 2 mm',
        name: 'ALUMINUM SHEET',
        thicknessMm: 2,
    },
    {
        description: 'ALUMINUM SHEET 2,5 mm',
        name: 'ALUMINUM SHEET',
        thicknessMm: 2.5,
    },
    {
        description: 'ALUMINUM SHEET 3 mm',
        name: 'ALUMINUM SHEET',
        thicknessMm: 3,
    },
    {
        description: 'ALUMINUM SHEET 4,5 mm',
        name: 'ALUMINUM SHEET',
        thicknessMm: 4.5,
    },
    {
        description: 'ALUMINUM SHEET 6 mm',
        name: 'ALUMINUM SHEET',
        thicknessMm: 6,
    },
])

/** Clases de finish de ejemplo (selector hasta definir origen dinámico). */
export const BRAKE_METALS_FINISH_CLASSES = Object.freeze([
    'MF',
    '2603 Stock Color',
    '2604 Stock Color',
    '2604 Custom Color',
    '2605 Stock Color',
    '2605 Custom Color',
])

export function brakeMetalsFinishRowKey(row) {
    const t =
        row.thicknessMm == null || row.thicknessMm === ''
            ? ''
            : String(Number(row.thicknessMm))
    return `${row.material || ''}|${t}|${row.finishClass || ''}`
}

export function brakeMetalsFinishDisplayName(row) {
    const t =
        row.thicknessMm == null || row.thicknessMm === ''
            ? ''
            : String(Number(row.thicknessMm))
    return `${row.material || ''} | ${t} mm | ${row.finishClass || ''}`
}
